import { Flex } from 'components';
import styled from 'styled-components';

export const TableCell = styled(Flex)<{ colored?: boolean }>`
  ${({ theme, colored }) =>
    colored ? `background-color: ${theme.palette.neutral.tableHeader};` : ''}
  min-height: 50px;
  padding: 0 6px;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.palette.neutral.tableHeader};
  font-size: ${({ theme }) => `${theme.textStyles.body2.fontSize}px`};
  font-weight: bold;
`;
